<script>
import { Line, mixins } from "vue-chartjs";
//import zoom from "chartjs-plugin-zoom";

export default {
    extends: [Line],
    mixins: [Line, mixins.reactiveData],
    //====================================================================
    props: {
        //chartOptions: {},
        chartDataChild: {},
        yRange: { min: Number, max: Number },
    },
    //====================================================================
    data() {
        return {
            //ymax: "15",
            chartOptions: {},
        };
    },
    //====================================================================
    created: function () {
        this.buildOption();
    },
    //====================================================================
    mounted() {
        //this.addPlugin(zoom);
        this.renderChart(this.chartDataChild, this.chartOptions);
    },
    //====================================================================
    watch: {
        chartDataChild: async function () {
            await this.buildOption();
            await this.renderChart(this.chartDataChild, this.chartOptions);
        },
    },
    //====================================================================
    methods: {
        buildOption() {
            //-------------------------------------------
            // 平均値のプラマイ4度をMin/Maxとする。
            //-------------------------------------------
            // let datasets = JSON.parse(JSON.stringify(this.chartDataChild.datasets));
            // let aryVal = [];
            // if (datasets.length) {
            //     for (let i in datasets[0].data) {
            //         let val = datasets[0].data[i].y;
            //         if (val) aryVal.push(val);
            //     }
            //     for (let i in datasets[1].data) {
            //         let val = datasets[1].data[i].y;
            //         if (val) aryVal.push(val);
            //     }
            //     const average = Math.floor(aryVal.reduce((acc, cur) => acc + cur) / aryVal.length);
            //     this.yRange.min = average - 4;
            //     this.yRange.max = average + 4;
            // }
            //-------------------------------------------
            this.chartOptions = {
                maintainAspectRatio: false,
                legend: { display: false, position: "bottom" },
                scales: {
                    xAxes: [
                        {
                            type: "time",
                            distribution: "linear", // use 'linear'(default) or 'series'
                            time: { displayFormats: { hour: "D日H時", day: "D日H時", month: "D日H時" } },
                            //ticks: { minRotation: 10, maxRotation: 40, maxTicksLimit: 9 },
                            ticks: { minRotation: 0, maxRotation: 0, maxTicksLimit: 4, fontColor: "#000" },
                            gridLines: { drawOnChartArea: true },
                        },
                    ],
                    yAxes: [
                        {
                            id: "axis-water-temp",
                            display: true,
                            position: "left",
                            scaleLabel: { display: false, labelString: "水温(℃)", fontColor: "navy" },
                            ticks: {
                                fontColor: "navy",
                                min: Number(this.yRange.min) ? Number(this.yRange.min) : 0,
                                max: Number(this.yRange.max) ? Number(this.yRange.max) : undefined,
                                stepSize: 1,
                            },
                        },
                    ],
                },
                tooltips: {
                    enabled: false,
                },
                elements: {
                    line: { tension: 0.2 }, // line: { tension: 0.4 },
                    //point: { radius: 1, hitRadius: 10, hoverRadius: 1, hoverBorderWidth: 3 },
                    point: false,
                },
                animation: false,
                //---- chartjs plugin zoom-----------
                // plugins: {
                //     zoom: {
                //         pan: {
                //             enabled: false,
                //             mode: "y",
                //             threshold: 10,
                //         },
                //         zoom: {
                //             enabled: false,
                //             mode: "y",
                //             wheel: {
                //                 enabled: true,
                //             },
                //             drag: {
                //                 enabled: false,
                //             },
                //             pinch: {
                //                 enabled: true,
                //             },
                //         },
                //         limits: {
                //             y: { min: -5, max: 40 },
                //         },
                //     },
                // },
                //---- chartjs plugin zoom-----------
            };
        },
    },
    //====================================================================
};
</script>
